@if (forced) {
    <div class="col-md-12">
        <div class="alert alert-warning">
            We've added an email address field to your profile. Please enter your email address.
        </div>
    </div>
}

@if (error) {
    <div class="col-md-12">
        <div class="alert alert-danger">{{ error }}</div>
    </div>
}

@if (success) {
    <div class="col-md-12">
        <div class="alert alert-success">Your email address was saved successfully.</div>
    </div>
}

<form [formGroup]="form" (ngSubmit)="handleSubmit()" class="form-horizontal">
    <div class="form-group">
        <label for="email" class="col-md-2 control-label">Email <span style="color: red">*</span></label>
        <div class="col-md-4">
            <input
                id="email"
                type="email"
                class="form-control"
                formControlName="email"
                autocomplete="email"
                placeholder="Enter your email" />
        </div>
    </div>
    <div class="form-group">
        <label for="confirmEmail" class="col-md-2 control-label">Confirm email <span style="color: red">*</span></label>
        <div class="col-md-4">
            <input
                id="confirmEmail"
                type="email"
                class="form-control"
                formControlName="confirmEmail"
                autocomplete="email"
                placeholder="Confirm your email address" />
        </div>
    </div>
    <div class="form-group">
        <div class="col-md-offset-2 col-md-4">
            <button type="submit" class="btn btn-default" [disabled]="submitting">
                {{ submitting ? "Saving..." : "Save Email" }}
            </button>
        </div>
    </div>
</form>
